import React, { useState, useEffect } from 'react';
import classes from './FestivalInfo.module.css';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../config';
import ReactDOM from 'react-dom';

const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M18 6L6 18M6 6L18 18" stroke="#565959" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const FestivalInfo = ({ id, onConfirm, onCancel }) => {
  const [festival, setFestival] = useState();

  useEffect(() => {
    setFestival();
    if (!id) return;
    const getFestival = async () => {
      const docRef = doc(db, "festivals", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) setFestival(docSnap.data());
    };
    getFestival();
    return () => setFestival();
  }, [id]);

  const handleClose = () => {
    onConfirm && onConfirm(false);
    onCancel && onCancel(false);
  };

  if (!festival) return null;

  return ReactDOM.createPortal(
    <>
      <div className={classes.backdrop} onClick={handleClose} />
      <div className={classes.sheet}>
        <div className={classes.handle} />
        <div className={classes.header}>
          <h2 className={classes.title}>{festival.name}</h2>
          <button className={classes.closeBtn} onClick={handleClose}>
            <CloseIcon />
          </button>
        </div>

        {/* Festival details */}
        <div className={classes.details}>
          {festival.location && (
            <div className={classes.detailRow}>
              <span className={classes.detailLabel}>Location</span>
              <span className={classes.detailValue}>{festival.location}{festival.country ? `, ${festival.country}` : ''}</span>
            </div>
          )}
          {festival.startdate && (
            <div className={classes.detailRow}>
              <span className={classes.detailLabel}>Dates</span>
              <span className={classes.detailValue}>
                {new Date(festival.startdate).toLocaleDateString('en-AU', { day: 'numeric', month: 'long' })}
                {festival.enddate && ` – ${new Date(festival.enddate).toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' })}`}
              </span>
            </div>
          )}
          {festival.hireurl && (
            <div className={classes.detailRow}>
              <span className={classes.detailLabel}>Hire gear</span>
              <a href={festival.hireurl} target="_blank" rel="noreferrer" className={classes.detailLink}>
                Book from festival →
              </a>
            </div>
          )}
        </div>

        <button className={classes.doneBtn} onClick={handleClose}>
          Done
        </button>
      </div>
    </>,
    document.body
  );
};

export default FestivalInfo;
